import { EmployerStaffRole, InvitedEmployerStaff } from 'src/api';

import { EmployerStaffInviteValues } from '../types';

export const prepareInviteData = (
  formFields: EmployerStaffInviteValues,
): { employerStaffList: InvitedEmployerStaff[] } => ({
  employerStaffList:
    formFields.users?.map(user => ({
      email: user.email,
      role: user.isAdmin ? EmployerStaffRole.EmployerAdmin : EmployerStaffRole.EmployerManager,
    })) || [],
});
